/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 01/20/2022
 *
 */

import React from 'react';
import '../common.css';
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";

// get table configurations
const table = tableConfigs.courseRoles;

class CourseRoles extends React.Component {
    constructor(props) {
        super(props);
        EventEmitter.emit('setPageHeaderData', {
            page: 'course-roles',
            pageName: "Course Roles",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/course-roles",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    render() {
        return(
            <div className={'page-mainLayout'}>
                <Table tableConfig={table} routerProps={this.props}/>
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Add Course Role"
                         onClick={() => this.props.history.push('/home/course-roles/create')}>
                        <i className="fa fa-plus fa-lg icon-primary" />
                    </div>
                </div>
            </div>
        )
    }
}

export default CourseRoles;
